export default __webpack_public_path__ + "static/Screen Shot 2021-12-01 at 20.02.01-c9d60dc55a33ae79a4ca6155dafea54f.png";